// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pHAC","largestCol":"styles_largestCol__2RqrW","smallestCol":"styles_smallestCol__1gHse"};